import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const StatusToggleModal = ({ isOpen, client, newStatus, onClose, onConfirm }) => {
  if (!isOpen || !client) return null;

  const isDeactivating = newStatus === 'inactive';

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-md bg-card rounded-xl elevation-2xl overflow-hidden">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
              isDeactivating ? 'bg-warning/20' : 'bg-success/20'
            }`}>
              <Icon 
                name={isDeactivating ? 'AlertTriangle' : 'CheckCircle'} 
                size={24} 
                color={isDeactivating ? 'var(--color-warning)' : 'var(--color-success)'} 
              />
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-heading font-semibold text-foreground mb-2">
                {isDeactivating ? 'Deactivate Client' : 'Activate Client'}
              </h2>
              <p className="text-sm text-muted-foreground font-body">
                Are you sure you want to {isDeactivating ? 'deactivate' : 'activate'} <span className="font-semibold text-foreground">{client?.companyName}</span>?
              </p>
            </div>
          </div>

          {isDeactivating && (
            <div className="p-4 bg-warning/10 border border-warning/20 rounded-md mb-6">
              <div className="flex items-start gap-2">
                <Icon name="Info" size={16} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
                <div className="space-y-1">
                  <p className="text-sm font-medium text-warning font-body">
                    User login access will be blocked
                  </p>
                  <p className="text-xs text-muted-foreground font-caption">
                    The client will not be able to access their account until reactivated.
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="flex gap-3">
            <Button
              type="button"
              variant="outline"
              size="lg"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant={isDeactivating ? 'warning' : 'success'}
              size="lg"
              onClick={onConfirm}
              iconName={isDeactivating ? 'XCircle' : 'CheckCircle'}
              iconPosition="left"
              fullWidth
            >
              {isDeactivating ? 'Deactivate' : 'Activate'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusToggleModal;